module.exports = __webpack_public_path__ + "static/media/logo2.e67dae1f.png";